import axios from "axios";
import { useNavigate } from "react-router-dom";
import axiosService from "../helpers/axios";

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

function useUserActions() {
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_API_URL;
    return {
        login,
        loginWithSocial,
        register,
        logout,
        edit,
        getUser,
    };

    function loginWithSocial(provider, data) {
        return axios.post(`${baseURL}/api/auth/${provider}/login/token/`, data)
            .then((res) => {
                // Registering the account and tokens in the store
                setUserData(res.data);
                navigate("/");
            })
            .catch((error) => {
                console.error(error);
            });
    }
    // Login the user
    function login(data) {
        return axios.post(`${baseURL}/api/auth/login/`, data)
            .then((res) => {
                // Registering the account and tokens in the store
                setUserData(res.data);
                navigate("/");
            })
            .catch((error) => {
                console.error(error);
                throw error;
                // Handle the error, e.g., display an error message to the user
            });
    }

    // Register user
    function register(data) {
        return axios.post(`${baseURL}/api/auth/register/`, data, {
            withCredentials: true
        }).then((res) => {
            // Registering the account and tokens in the store
            setUserData(res.data);
            navigate("/");
        });
    }

    // Logout the user
    function logout() {
        return axiosService
            .post(`${baseURL}/api/auth/logout/`, { refresh: getRefreshToken() })
            .then(() => {
                console.log("Calling logout");
                localStorage.removeItem("auth");
                navigate("/login");
            })
            .catch(error => {
                console.log(error);
                localStorage.removeItem("auth");
                navigate("/login");
            });
    }

    function edit(data, userId) {
        return axiosService
            .patch(`${baseURL}/user/${userId}/`, data, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then((res) => {
                // Registering the account in the store
                localStorage.setItem(
                    "auth",
                    JSON.stringify({
                        access: getAccessToken(),
                        refresh: getRefreshToken(),
                        user: res.data,
                    })
                );
            });
    }

    function getUser() {
        const auth = JSON.parse(localStorage.getItem("auth")) || null;
        if (auth) {
            return auth.user;
        } else {
            return null;
        }
    }
}

// Set the access, token, and user property
function setUserData(data) {
    localStorage.setItem(
        "auth",
        JSON.stringify({
            access: data.access,
            refresh: data.refresh,
            user: data.user,
        })
    );
}

// Get the access token
function getAccessToken() {
    const auth = JSON.parse(localStorage.getItem("auth"));
    return auth.access;
}

// Get the refresh token
function getRefreshToken() {
    const auth = JSON.parse(localStorage.getItem("auth"));
    return auth.refresh;
}


export { useUserActions, getAccessToken, getRefreshToken, setUserData };